import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col, message, Upload, Switch, Select, InputNumber, Tooltip } from "antd";
import { PictureOutlined, PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { FormItem, InputItem, InputNumberItem, SelectItem, TextAreaItem, DynamicCardForm, ButtonItem, SelectInsumosItem } from "../../../../Components/Items";
import ModalFormCMMS from "../componentes/ModalFormCMMS";
import { IconTiposDeActivo } from "../../../../Icons/Icons";
import { cmmsPost, normFile, fileListAPayload, TIPOS_SERVICIO } from "../cmmsComun";

const { Option } = Select;


// Alta / edicion de un Tipo de Activo (modo "agregar" | "editar").
class ModalTipoActivo extends Component {
    formRef = React.createRef();
    // rutinas y kit se manejan en estado (listas cortas con agregar / quitar).
    state = { loading: false, requiereSeguridadElectrica: false, rutinasDisponibles: [], rutinas: [], kit: [] };

    componentDidUpdate(prevProps) {
        if (this.props.visible && !prevProps.visible) {
            this.formRef.current?.resetFields();
            this.setState({ requiereSeguridadElectrica: false, rutinas: [], kit: [] });
            this.consultarRutinas();
            if (this.props.modo === "editar" && this.props.tipoId) this.consultarTipo();
        }
    }

    consultarRutinas = async () => {
        try {
            const res = await cmmsPost(this.props, "selectRutinasCMMS", { valor: 1 });
            if (res.data.success === 2) this.setState({ rutinasDisponibles: res.data.rutinas });
        } catch (error) {
            console.log(error);
        }
    };

    consultarTipo = async () => {
        this.setState({ loading: true });
        try {
            const res = await cmmsPost(this.props, "datosTipoEquipo", { id: this.props.tipoId });
            if (res.data.success !== 2) return message.error(res.data.message || "No se encontró el tipo de activo");
            const tipo = res.data.tipo;
            this.formRef.current?.setFieldsValue({
                ...tipo,
                imagen: tipo.imagen ? [{ uid: "img", name: "imagen", status: "done", url: "../" + tipo.imagen, urlRelativa: tipo.imagen }] : [],
            });
            this.setState({
                requiereSeguridadElectrica: !!tipo.requiereSeguridadElectrica,
                rutinas: (tipo.rutinas || []).map((x) => ({ tipoServicio: x.tipoServicio, rutinaId: x.rutinaId })),
                kit: (tipo.kitRefacciones || []).map((k, i) => ({ llave: `k${i}`, insumoId: k.insumoId, insumo: k.insumo, cantidad: k.cantidad })),
            });
        } catch (error) {
            console.log(error);
            message.error("Error al consultar el tipo de activo");
        } finally {
            this.setState({ loading: false });
        }
    };

    onFinish = async (values) => {
        this.setState({ loading: true });
        try {
            const [imagen] = await fileListAPayload(values.imagen);
            const payload = {
                ...values,
                id: this.props.tipoId,
                imagen: imagen || null,
                requiereSeguridadElectrica: this.state.requiereSeguridadElectrica,
                rutinas: this.state.rutinas.filter((x) => x.tipoServicio && x.rutinaId),
                kitRefacciones: this.state.kit.filter((k) => k.insumoId).map((k) => ({ insumoId: k.insumoId, cantidad: k.cantidad || 1 })),
            };
            const ruta = this.props.modo === "editar" ? "editarTipoEquipo" : "agregarTipoEquipo";
            const res = await cmmsPost(this.props, ruta, payload);
            if (res.data.success === 2) {
                message.success(this.props.modo === "editar" ? "Tipo de activo actualizado" : "Tipo de activo registrado");
                this.props.onClose(res.data.codigo);
            } else {
                message.error(res.data.message || "No se pudo guardar el tipo de activo");
            }
        } catch (error) {
            console.log(error);
            message.error("No se pudo guardar el tipo de activo");
        } finally {
            this.setState({ loading: false });
        }
    };

    render() {
        const editar = this.props.modo === "editar";
        return (
            <ModalFormCMMS
                titulo={editar ? "Editar tipo de activo" : "Nuevo tipo de activo"}
                subtitulo="Los activos de este tipo heredan su configuración de mantenimiento."
                icono={<IconTiposDeActivo size={22} color="#2fb8d6" marginRight={0} />}
                visible={this.props.visible}
                loading={this.state.loading}
                onCancel={() => this.props.onClose()}
                formRef={this.formRef}
                name="tipoActivoCMMS"
                onFinish={this.onFinish}
                textoGuardar={editar ? "Guardar cambios" : "Registrar tipo"}
                width={820}
            >
                <DynamicCardForm title="Datos" xs={24} lg={16}>
                    <Row gutter={12}>
                        <Col xs={24} md={16}>
                            <FormItem
                                label="Nombre"
                                name="nombre"
                                required
                                max={150}
                                tooltip="Nombre del tipo de equipo, ej. Ventilador Mecánico. Debe ser único: el importador de Excel lo usa para asociar cada renglón con su tipo."
                            >
                                <InputItem placeholder="Ej. Ventilador Mecánico" />
                            </FormItem>
                        </Col>
                        <Col xs={24} md={8}>
                            <FormItem label="Clave" name="clave" max={30} tooltip="Clave corta opcional para listados y reportes.">
                                <InputItem placeholder="Ej. VENT" />
                            </FormItem>
                        </Col>
                    </Row>
                    <FormItem label="Descripción" name="descripcion">
                        <TextAreaItem rows={2} placeholder="Descripción del tipo de equipo" />
                    </FormItem>
                </DynamicCardForm>

                <DynamicCardForm title="Imagen" xs={24} lg={8}>
                    <div className="cmms-upload-centrado">
                        <FormItem name="imagen" valuePropName="fileList" getValueFromEvent={normFile} noStyle>
                            <Upload
                                listType="picture-card"
                                maxCount={1}
                                accept="image/*"
                                beforeUpload={(file) => {
                                    if (file.size / 1024 / 1024 >= 5) {
                                        message.error("La imagen debe pesar menos de 5MB");
                                        return Upload.LIST_IGNORE;
                                    }
                                    return false;
                                }}
                            >
                                <div>
                                    <PictureOutlined style={{ fontSize: 22, color: "#2fb8d6" }} />
                                    <div style={{ marginTop: 8, fontSize: 12 }}>Subir imagen</div>
                                </div>
                            </Upload>
                        </FormItem>
                    </div>
                    <div className="cmms-ayuda" style={{ textAlign: "center", marginTop: 8 }}>
                        Opcional. Ayuda a reconocer el tipo en listados.
                    </div>
                </DynamicCardForm>

                <DynamicCardForm title="Rutinas" xs={24} lg={12}>
                    <div className="cmms-ayuda">La rutina de cada tipo de servicio se precarga al abrir un servicio de un equipo de este tipo. El ingeniero puede ajustarla en el servicio.</div>
                    {this.state.rutinas.map((x, i) => (
                        <div key={i} style={{ display: "flex", gap: 6, marginBottom: 6 }}>
                            <Select
                                value={x.tipoServicio}
                                style={{ width: 190 }}
                                onChange={(tipoServicio) => this.setState((s) => ({ rutinas: s.rutinas.map((y, j) => (j === i ? { ...y, tipoServicio } : y)) }))}
                            >
                                {TIPOS_SERVICIO.map((t) => (
                                    <Option key={t.value} value={t.value} disabled={this.state.rutinas.some((y, j) => j !== i && y.tipoServicio === t.value)}>
                                        {t.label}
                                    </Option>
                                ))}
                            </Select>
                            <Select
                                showSearch
                                optionFilterProp="children"
                                placeholder="Rutina"
                                value={x.rutinaId || undefined}
                                style={{ flex: 1, minWidth: 0 }}
                                onChange={(rutinaId) => this.setState((s) => ({ rutinas: s.rutinas.map((y, j) => (j === i ? { ...y, rutinaId } : y)) }))}
                            >
                                {this.state.rutinasDisponibles.map((rt) => (
                                    <Option key={rt._id} value={rt._id}>
                                        {[rt.codigo, rt.titulo].filter(Boolean).join(" - ")}
                                    </Option>
                                ))}
                            </Select>
                            <Tooltip title="Quitar">
                                <ButtonItem type="default" htmlType="button" rojo icon={<DeleteOutlined />} onClick={() => this.setState((s) => ({ rutinas: s.rutinas.filter((_, j) => j !== i) }))} />
                            </Tooltip>
                        </div>
                    ))}
                    <ButtonItem
                        type="dashed"
                        htmlType="button"
                        icon={<PlusOutlined />}
                        onClick={() =>
                            this.setState((s) => {
                                const libre = TIPOS_SERVICIO.find((t) => !s.rutinas.some((y) => y.tipoServicio === t.value));
                                return libre ? { rutinas: [...s.rutinas, { tipoServicio: libre.value, rutinaId: null }] } : null;
                            })
                        }
                    >
                        Agregar rutina
                    </ButtonItem>
                    {!this.state.rutinasDisponibles.length && <div className="cmms-ayuda" style={{ marginTop: 8 }}>Aún no hay rutinas. Créelas en Mantenimiento › Rutinas.</div>}
                </DynamicCardForm>

                <DynamicCardForm title="Kit de refacciones" xs={24} lg={12}>
                    <div className="cmms-ayuda">Refacciones que se sugieren al abrir un servicio de este tipo (se pueden quitar o cambiar en el servicio).</div>
                    {this.state.kit.map((k, i) => (
                        <div key={k.llave} style={{ display: "flex", gap: 6, marginBottom: 6, alignItems: "center" }}>
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <SelectInsumosItem
                                    empresaId={this.props.empresaId}
                                    headersToken={this.props.headersToken}
                                    placeholder="Refacción"
                                    width="100%"
                                    value={k.insumoId || undefined}
                                    insumoPreCargado={k.insumo}
                                    onChange={(insumoId, insumo) => this.setState((s) => ({ kit: s.kit.map((y, j) => (j === i ? { ...y, insumoId, insumo } : y)) }))}
                                />
                            </div>
                            <InputNumber
                                min={1}
                                value={k.cantidad}
                                style={{ width: 80 }}
                                onChange={(cantidad) => this.setState((s) => ({ kit: s.kit.map((y, j) => (j === i ? { ...y, cantidad } : y)) }))}
                            />
                            <ButtonItem type="default" htmlType="button" rojo icon={<DeleteOutlined />} onClick={() => this.setState((s) => ({ kit: s.kit.filter((_, j) => j !== i) }))} />
                        </div>
                    ))}
                    <ButtonItem
                        type="dashed"
                        htmlType="button"
                        icon={<PlusOutlined />}
                        onClick={() => this.setState((s) => ({ kit: [...s.kit, { llave: `n${Date.now()}`, insumoId: null, insumo: null, cantidad: 1 }] }))}
                    >
                        Agregar refacción
                    </ButtonItem>
                </DynamicCardForm>

                <DynamicCardForm title="Mantenimiento" xs={24}>
                    <Row gutter={12}>
                        <Col xs={24} md={8}>
                            <FormItem
                                label="Preventivo cada (meses)"
                                name="periodicidadMeses"
                                numberCero
                                tooltip="Cada cuántos meses le toca preventivo a un equipo de este tipo que NO esté en un contrato. Con esto se sugiere su próximo preventivo. Los equipos en contrato siguen las vueltas del contrato."
                            >
                                <InputNumberItem placeholder="Ej. 6" min={0} />
                            </FormItem>
                        </Col>
                        <Col xs={24} md={8}>
                            <FormItem
                                label="Tiempo estimado (minutos)"
                                name="duracionEstimadaMin"
                                numberCero
                                tooltip="Duración aproximada de un preventivo. Se muestra en la ficha del activo como Tiempo Estimado MPrev."
                            >
                                <InputNumberItem placeholder="Ej. 60" min={0} />
                            </FormItem>
                        </Col>
                        <Col xs={24} md={8}>
                            <FormItem label="Seguridad eléctrica" tooltip="Indica que este tipo de equipo lleva prueba de seguridad eléctrica en su servicio (se usará en rutinas y certificados).">
                                <div className="cmms-switch-linea">
                                    <Switch
                                        size="small"
                                        checked={this.state.requiereSeguridadElectrica}
                                        onChange={(requiereSeguridadElectrica) => this.setState({ requiereSeguridadElectrica })}
                                    />
                                    {this.state.requiereSeguridadElectrica ? "Sí requiere prueba" : "No requiere prueba"}
                                </div>
                            </FormItem>
                        </Col>
                    </Row>
                    <FormItem
                        label="Nombres alternos"
                        name="aliasImportacion"
                        tooltip="Otras formas en que viene escrito este tipo en los inventarios de los clientes (ej. ECG, Electrocardiografo). Al importar un Excel, un renglón con cualquiera de estos nombres se asocia a este tipo."
                    >
                        <SelectItem mode="tags" placeholder="Escriba cada nombre y presione Enter" noBuscar />
                    </FormItem>
                </DynamicCardForm>
            </ModalFormCMMS>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalTipoActivo);
